import React from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SimpleTreeView } from "@mui/x-tree-view";
function TreeView({ slots, ...otherProps }) {
  const handleClick = (e) => {
    e.stopPropagation();
  };
  return /* @__PURE__ */ React.createElement(
    SimpleTreeView,
    {
      ...otherProps,
      onClick: handleClick,
      slots: {
        expandIcon: slots?.expandIcon ?? ExpandMore,
        collapseIcon: slots?.collapseIcon ?? ExpandLess
      }
    }
  );
}
export {
  TreeView
};
//# sourceMappingURL=TreeView.js.map
